module.exports = __webpack_public_path__ + "static/media/sliders.40f0b50e.less";